import type {User} from 'src/typings';
import type UserService from '../../../user/user.service';

export class KpSearchItemUserPresenter {
    public static presenterName = 'kpSearchItemPresenter';

    /*@ngInject*/
    constructor(private userService: UserService) {}

    public editUser(user: User) {
        return this.userService.editUserByForm(user);
    }

    public async deleteUser(user: User) {
        await this.userService.deleteUser(user);
    }
}